import { css } from 'aphrodite';
import { memo } from 'react';
import { styleSheet } from './styles';

interface IProps {
	className?: string;
	type?: 'login' | 'large' | 'small' | 'extra-small' | 'tiny' | 'extra-tiny' | 'loginSecondary';
	'data-testid'?: string;
}

const SPINNER_STYLE_BY_TYPE = {
	login: styleSheet.loadingLogin,
	loginSecondary: styleSheet.loadingLoginSecondary,
	large: styleSheet.loadingLarge,
	small: styleSheet.loadingSmall,
	'extra-small': styleSheet.loadingExtraSmall,
	'extra-tiny': styleSheet.loadingExtraTiny,
	tiny: styleSheet.loadingTiny,
} as const;

/**
 * Functional + memoized (preserves the prior PureComponent shallow-prop skip). Converted from a
 * class component so plugin-v2 can consume main primitives (e.g. Button) without importing a
 * React class component — see packages/plugin-v2 import guard.
 */
export const LoadingSpinner = memo(function LoadingSpinner({ className, type, 'data-testid': dataTestId }: IProps) {
	const spinnerStyle = (type && SPINNER_STYLE_BY_TYPE[type]) || styleSheet.loadingSmall;
	return (
		<div className={`loading-spinner ${className || ''}`} role='loading-spinner' data-testid={dataTestId}>
			<div className={`loading-spinner-spinner ${css(spinnerStyle)}`} />
		</div>
	);
});
